import axios from "../../axios";

const getPartnerStatistics = async (token, data) => {
    const requestData = {
        userId: data.userId,
        startDate: data.startDate,
        endDate: data.endDate
    };

    try {
        const response = await axios.post('/deduction-fees/getPartnerStatistics', requestData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        
        return response.data;
    } catch (error) {
        if (error.response && error.response.data) {
            return error.response.data;
        }
        return {
            success: false,
            message: "Network error",
            errorCode: 500
        };
    }
};

export default getPartnerStatistics; 
